import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

function ListItemLink({
    Icon, primary, to, onClick,
}) {
    const renderLink = React.useMemo(
        () => React.forwardRef((itemProps, ref) => <RouterLink to={to} ref={ref} {...itemProps} />),
        [to],
    );

    return (
        <ListItem button component={renderLink} onClick={onClick}>
            {Icon ? <ListItemIcon><Icon /></ListItemIcon> : null}
            <ListItemText primary={primary} />
        </ListItem>
    );
}

export default ListItemLink;
